module.exports = __webpack_public_path__ + "img/iloilo_b_70121.157511b6.jpg";